<template>
  <div class="page-container">
    <el-breadcrumb>
      <el-breadcrumb-item>PSI分红</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <fieldset>
        <legend>分红</legend>
        <div class="page-actions">
          <el-autocomplete
            class="inline-input"
            v-model="coinType"
            :fetch-suggestions="querySearch"
            placeholder="请输入币种"
            @select="handleSelect"
            @keyup.native.enter="handleSearch"
          >
            <i
              class="el-icon-close el-input__icon"
              slot="suffix"
              @click="cleanSearchCoin"
              style="cursor: pointer"
            >
            </i>
          </el-autocomplete>
          <el-input placeholder="请输入分红总量" v-model="bonus"></el-input>
          <el-date-picker
            v-model="snapshotTime"
            type="datetime"
          ></el-date-picker>
          <el-button @click="handleSend" type="danger">发送</el-button>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          {{ countNum || countNum === 0 ? '查询人数:' + countNum : '查询人数' }}
        </legend>
        <div class="page-actions">
          <el-autocomplete
            class="inline-input"
            v-model="conuntCoinType"
            :fetch-suggestions="querySearch"
            placeholder="请输入币种"
            @select="handleSelect"
            @keyup.native.enter="handleSearch"
          >
            <i
              class="el-icon-close el-input__icon"
              slot="suffix"
              @click="conuntCoinType = ''"
              style="cursor: pointer"
            >
            </i>
          </el-autocomplete>
          <el-date-picker
            v-model="conuntSnapshotTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择查询时间"
          >
          </el-date-picker>
          <el-button @click="getPartInCount" type="success">查询人数</el-button>
          <span v-if="countNum || countNum === 0" class="searcResult"
            >当前查询结果为:{{ countNum }}</span
          >
        </div>
      </fieldset>
      <fieldset>
        <legend>分红纪录</legend>
        <div class="tb-wrapper">
          <el-input
            placeholder="请输入查询币种"
            v-model="listCoinType"
          ></el-input>
          <el-input placeholder="请输入userId" v-model="listUserId"></el-input>
          <el-date-picker
            v-model="timeBucket"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          >
          </el-date-picker>
          <el-button
            @click="searchList()"
            type="success"
            style="margin-left:20px"
            >查询列表</el-button
          >
          <el-table :data="list">
            <el-table-column label="id" prop="id"></el-table-column>
            <el-table-column label="币种" prop="coinType"></el-table-column>
            <el-table-column label="时间">
              <template slot-scope="scope">{{
                scope.row.bonusTime | moment
              }}</template>
            </el-table-column>
            <el-table-column label="user_id" prop="userId"></el-table-column>
            <el-table-column
              label="总持仓"
              prop="totalBalance"
            ></el-table-column>
            <el-table-column
              label="个人持仓"
              prop="selfBalance"
            ></el-table-column>
            <el-table-column label="总分红" prop="totalBonus"></el-table-column>
            <el-table-column
              label="个人分红"
              prop="selfBonus"
            ></el-table-column>
          </el-table>
        </div>
        <div class="pager-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="prev, pager, next, jumper"
            :total="listTotal"
          ></el-pagination>
        </div>
      </fieldset>
    </el-card>
  </div>
</template>

<script>
import './store';
import api from './api';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TransferPsi',
  data() {
    let defaultTime = new Date();
    defaultTime.setHours(10);
    defaultTime.setMinutes(0);
    defaultTime.setSeconds(0);
    return {
      bonus: '',
      coinType: '',
      snapshotTime: defaultTime,
      pagination: {
        page: 1,
        size: 6
      },
      listCoinType: '',
      listUserId: '',
      timeBucket: [],

      conuntSnapshotTime: '',
      conuntCoinType: ''
    };
  },
  computed: {
    ...mapState('transferPsi', ['list', 'listTotal', 'countNum'])
  },
  methods: {
    ...mapActions('transferPsi', ['getList', 'sendBonus', 'getCount']),

    getPartInCount() {
      this.getCount({
        snapshotTime: this.conuntSnapshotTime,
        coinType: this.conuntCoinType
      });
    },

    searchList() {
      this.pagination.page = 1;
      this.refreshList();
    },
    refreshList() {
      let addParams = {
        bonusTimeStart: this.timeBucket[0],
        bonusTimeEnd: this.timeBucket[1],
        userId: this.listUserId,
        coinType: this.listCoinType
      };
      this.getList({
        ...this.pagination,
        ...addParams
      });
    },
    handleSend() {
      if (this.coinType && this.bonus && this.snapshotTime) {
        this.sendBonus({
          coinType: this.coinType,
          bonus: this.bonus,
          snapshotTime: this.snapshotTime.getTime()
        }).then(() => {
          this.bonus = '';
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.pagination.page = 1;
          this.refreshList();
        });
      }
    },
    handleCurrentChange() {
      this.refreshList();
    },
    handleSizeChange() {},
    getAllSupportCoin() {
      api.getAllSupportCoin().then(({ data }) => {
        this.coinTypes = data;
      });
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.coinTypes;
      results = queryString
        ? coinList.filter(this.createFilter(queryString))
        : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return tempData => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect() {},
    cleanSearchCoin() {
      this.coinType = '';
    }
  },
  created() {
    this.refreshList();
    this.getAllSupportCoin();
  }
};
</script>

<style lang="less" scoped>
.el-input {
  width: 300px;
  margin-right: 10px;
}
.tb-wrapper {
  margin: 20px 0px;
}
.pager-wrapper {
  text-align: right;
}

fieldset {
  border-color: #76e6898a;
  margin-bottom: 20px;
  padding: 20px 0 20px 20px;
  legend {
    color: #409eff;
    font-size: 16px;
    font-weight: bold;
  }
}
.searcResult {
  color: #409eff;
  font-size: 16px;
}
</style>
